// Utility functions for room-related operations

export const formatDuration = (seconds) => {
  if (!seconds) return '0:00'
  const mins = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

export const formatRelativeTime = (timestamp) => {
  const date = new Date(timestamp)
  const now = new Date()
  const diff = now - date
  
  const minutes = Math.floor(diff / 60000)
  const hours = Math.floor(diff / 3600000)
  const days = Math.floor(diff / 86400000)
  
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  if (hours < 24) return `${hours}h ago`
  return `${days}d ago`
}

export const extractVideoTitle = (url) => {
  try {
    const videoId = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/)?.[1]
    return videoId ? `YouTube Video ${videoId.slice(0, 8)}...` : 'Unknown Video'
  } catch {
    return 'Unknown Video'
  }
}

export const isYouTubeUrl = (url) => {
  const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/)|youtu\.be\/)/i
  return youtubeRegex.test(url.trim())
}

// Queue filtering helpers
export const getActiveQueue = (queue) => queue.filter(item => item.status === 'playing' || item.status === 'queued')
export const getHistoryQueue = (queue) => queue.filter(item => item.status === 'played')

// Get user-specific processing jobs
export const getUserProcessingJobs = (processingJobs) => {
  // Get all processing jobs from the store and filter for active ones
  const allJobs = Array.from(processingJobs.values())
  const activeJobs = allJobs.filter(job => 
    job.status === 'pending' || job.status === 'processing'
  )
  
  // Filter for current user (simple client-side filter)
  // Note: In production, you'd want server-side filtering based on user authentication
  return activeJobs.filter(job => {
    // For now, we can't filter by user since processing_jobs table doesn't have addedBy field
    // This would need to be added in a future migration
    return true // Show all active jobs for now
  })
} 